export const generateFullName = (firstName?: string, lastName?: string, middleName?: string, fallback = "") => {
    return firstName || lastName || middleName ? `${lastName ?? ""} ${firstName ?? ""} ${middleName ?? ""}` : fallback
}
